import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { cn } from '@/lib/utils';
import React from 'react';

interface SortableBlockWrapperProps {
  id: string;
  children: React.ReactNode;
}

export const SortableBlockWrapper = ({ id, children }: SortableBlockWrapperProps) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cn(
        isDragging && "opacity-50 z-50 shadow-xl scale-[1.02]"
      )}
      {...attributes}
    >
      {/* Pass only listeners to children for drag handle */}
      {React.Children.map(children, child => {
        if (React.isValidElement(child)) {
          return React.cloneElement(child as React.ReactElement<{ dragHandleProps?: Record<string, unknown> }>, {
            dragHandleProps: listeners,
          });
        }
        return child;
      })}
    </div>
  );
};
